export default __webpack_public_path__ + "static/media/logo_ies_bco.93e06dd7.png";